import { BsPencil } from 'react-icons/bs';
import { daysOfTheWeekP, daysOfTheWeekS, generalHelpers, typesOfPreaching } from '@monorepo/helpers';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { PublicMinistryCrudServiceModal } from './PublicMinistryCrudServiceModal';
import { typePublicMinistryDoc, typePublicMinistryMonthlyService, typePublicMinistryService, typeUser } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    monthlyService: typePublicMinistryMonthlyService;
    publicMinistryDoc: typePublicMinistryDoc;
    readOnly?: boolean;
    setMonthlyService: Dispatch<SetStateAction<typePublicMinistryMonthlyService>>;
    users: typeUser[];
};

export const PublicMinistryByType: FC<propsType> = ({ monthlyService, publicMinistryDoc, readOnly, setMonthlyService, users }) => {
    return (
        <div>
            <TypeTable
                monthlyService={monthlyService}
                publicMinistryDoc={publicMinistryDoc}
                readOnly={readOnly}
                services={monthlyService.services
                    .filter(s => s.typeOfRegularity === 1)
                    .sort((s1, s2) => ((s1.weekday! || 7) - (s2.weekday! || 7)) || (s1.hour - s2.hour) || (s1.minutes - s2.minutes))
                }
                setMonthlyService={setMonthlyService}
                title={'SALIDAS SEMANALES'}
                users={users}
            />
            <TypeTable
                monthlyService={monthlyService}
                publicMinistryDoc={publicMinistryDoc}
                readOnly={readOnly}
                services={monthlyService.services
                    .filter(s => s.typeOfRegularity === 2)
                    .sort((s1, s2) => ((s1.groups![0] - s2.groups![0]) || (s1.weekday! || 7) - (s2.weekday! || 7)) || (s1.hour - s2.hour) || (s1.minutes - s2.minutes))
                }
                setMonthlyService={setMonthlyService}
                title={'SALIDAS SEMANALES DE GRUPOS'}
                users={users}
            />
            <TypeTable
                monthlyService={monthlyService}
                publicMinistryDoc={publicMinistryDoc}
                readOnly={readOnly}
                services={monthlyService.services
                    .filter(s => s.typeOfRegularity === 3)
                    .sort((s1, s2) => (s1.day! - s2.day!) || (s1.hour - s2.hour) || (s1.minutes - s2.minutes))
                }
                setMonthlyService={setMonthlyService}
                title={'SALIDAS ESPECIALES'}
                users={users}
            />
            <TypeTable
                monthlyService={monthlyService}
                publicMinistryDoc={publicMinistryDoc}
                readOnly={readOnly}
                services={monthlyService.services
                    .filter(s => s.typeOfRegularity === 4)
                    .sort((s1, s2) => (s1.groups![0] - s2.groups![0]) || (s1.day! - s2.day!) || (s1.hour - s2.hour) || (s1.minutes - s2.minutes))
                }
                setMonthlyService={setMonthlyService}
                title={'SALIDAS ESPECIALES DE GRUPOS'}
                users={users}
            />
            <TypeTable
                monthlyService={monthlyService}
                publicMinistryDoc={publicMinistryDoc}
                readOnly={readOnly}
                services={monthlyService.services
                    .filter(s => s.typeOfRegularity === 5)
                    .sort((s1, s2) => (s1.day! - s2.day!) || (s1.hour - s2.hour) || (s1.minutes - s2.minutes))
                }
                setMonthlyService={setMonthlyService}
                title={'SALIDAS DE LA VISITA'}
                users={users}
            />
        </div>
    )
}

type propsType1 = {
    monthlyService: typePublicMinistryMonthlyService;
    publicMinistryDoc: typePublicMinistryDoc;
    readOnly?: boolean;
    services: typePublicMinistryService[];
    setMonthlyService: Dispatch<SetStateAction<typePublicMinistryMonthlyService>>;
    title: string;
    users: typeUser[];
};

const TypeTable: FC<propsType1> = ({ monthlyService, publicMinistryDoc, readOnly, services, setMonthlyService, title, users }) => {
    const [serviceToEdit,setServiceToEdit] = useState<typePublicMinistryService | null>(null);
    const isDarkMode = useGetIsDarkMode();
    const lastDayOfTheMonth = generalHelpers.GetDaysOfMonth(monthlyService.month, monthlyService.year);

    if (services.some(s => s.typeOfRegularity === 5) && lastDayOfTheMonth > 1) {
        const previous = publicMinistryDoc.monthlyServices.find(ms =>
            monthlyService.month === 0 ?
                ms.year === monthlyService.year - 1 && ms.month === 11
                :
                ms.year === monthlyService.year && ms.month === monthlyService.month - 1
        );
        const next = publicMinistryDoc.monthlyServices.find(ms =>
            monthlyService.month === 11 ?
                ms.year === monthlyService.year + 1 && ms.month === 0
                :
                ms.year === monthlyService.year && ms.month === monthlyService.month + 1
        );
        const circuitPreviousMonth = previous?.services.filter(s => s.typeOfRegularity === 5).sort((s1, s2) => s2.day! - s1.day!);
        if (circuitPreviousMonth) {
            for (const s of circuitPreviousMonth) {
                services.unshift({ ...s, isOtherMonth: true });
            }
        }
        const circuitNextMonth = next?.services.filter(s => s.typeOfRegularity === 5);
        if (circuitNextMonth) {
            for (const s of circuitNextMonth) {
                services.push({ ...s, isOtherMonth: true });
            }
        }
    }

    if (readOnly && !services.length) {
        return <></>;
    }

    return (
        <div>
            {serviceToEdit &&
                <PublicMinistryCrudServiceModal
                    closeModal={() => setServiceToEdit(null)}
                    deleteService={(service: typePublicMinistryService) => {
                        setMonthlyService(x => ({
                            ...x!,
                            services: x!.services.filter(s => s.id !== service.id)
                        }));
                    }}
                    editService={(service: typePublicMinistryService) => {
                        setMonthlyService(x => ({
                            ...x!,
                            services: x!.services.map(s => s.id === service.id ? service : s)
                        }));
                    }}
                    monthlyService={monthlyService}
                    serviceToEdit={serviceToEdit}
                    users={users}
                />
            }
            <h5 className={'text-center mt-5 mb-3'}>
                {title}
            </h5>
            {services.length ?
                <div className={'table-responsive'}>
                    <table className={`table table-striped table-bordered ${isDarkMode ? 'table-dark' : 'table-light'} small`}>
                        <thead>
                            <tr>
                                <th>Día</th>
                                <th>Hora</th>
                                <th>Predicación</th>
                                {services.some(s => s.groups) &&
                                    <th>Grupos</th>
                                }
                                <th>Lugar</th>
                                <th>Conductor(es)</th>
                                <th>Territorios</th>
                                <th>Observaciones</th>
                                {!readOnly &&
                                    <th>Editar</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {services.map(s => {
                                const weekday = s.day ? new Date(monthlyService.year, monthlyService.month, s.day).getDay() : null;
                                return (
                                    <tr key={s.id}>
                                        <td>
                                            {s.weekday !== null ?
                                                daysOfTheWeekP[s.weekday]
                                                :
                                                weekday !== null ? <>{daysOfTheWeekS[weekday]} {s.day}</> : ''
                                            }
                                        </td>
                                        <td>
                                            {s.hour.toString().padStart(2, '0')}:{s.minutes.toString().padStart(2, '0')}
                                        </td>
                                        <td className={'text-nowrap'}>
                                            {typesOfPreaching.find(tp => tp.type === s.typeOfPreaching)?.label}
                                        </td>
                                        {services.some(s => s.groups) &&
                                            <td>
                                                {s.groups.join(', ')}
                                            </td>
                                        }
                                        <td>
                                            {s.address1}
                                            {s.address2 && <><br />{s.address2}</>}
                                        </td>
                                        <td>
                                            {s.captain1 ?
                                                <div>
                                                    {s.captain1.name} {s.captain1.lastName}
                                                </div>
                                                :
                                                '-'
                                            }
                                            {s.captain2 &&
                                                <div>
                                                    {s.captain2.name} {s.captain2.lastName}
                                                </div>
                                            }
                                        </td>
                                        <td>
                                            {s.territories.join(', ')}
                                        </td>
                                        <td>
                                            {s.observation}
                                        </td>
                                        {!readOnly &&
                                            <td>
                                                {!s.isOtherMonth &&
                                                    <button className={'btn btn-sm btn-yellow text-white w-100'}
                                                        onClick={() => setServiceToEdit(s)}
                                                    >
                                                        <BsPencil className={'mb-1 me-2'} />Editar
                                                    </button>
                                                }
                                            </td>
                                        }
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                :
                <div className={'text-center mb-5'}>
                    No Hay
                </div>
            }
        </div>
    )
}
